import { useState, useEffect } from 'react';
import useSWR from 'swr';
import { getEntityImage } from '@/publicSearch/api';
import {
  DocumentImageSize,
  DocumentTypeCode,
  EApiKey,
} from '@/publicSearch/constants';

export function useImageFromEntity(
  entityGuid: string,
  orgId: string,
  size: DocumentImageSize,
  type: DocumentTypeCode = DocumentTypeCode.Image,
) {
  const {
    data: imgData,
    isLoading: isLoadingImg,
    error: imgError,
  } = useSWR(
    () =>
      !!entityGuid && !!orgId
        ? [EApiKey.GET_ENTITY_IMAGE, entityGuid, orgId]
        : false,
    () => getEntityImage(entityGuid, type, size, orgId),
  );

  const [imgUrl, setImgUrl] = useState('');

  useEffect(() => {
    return () => {
      if (imgUrl) {
        URL.revokeObjectURL(imgUrl);
      }
    };
  }, [imgUrl]);

  useEffect(() => {
    if (imgData instanceof Blob && imgData.size > 0) {
      const objectUrl = URL.createObjectURL(imgData);
      // eslint-disable-next-line react-hooks/set-state-in-effect -- creates an object URL from an async-fetched Blob (revoked by the separate cleanup effect); object-URL creation, not a synchronous derivation
      setImgUrl(objectUrl);
    }
  }, [imgData]);

  return {
    imgUrl,
    imgError,
    isLoadingImg,
  };
}
